import React from 'react';
import styled from 'styled-components';
import LocalTime from '../common/localTime';

const Foot = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem;
  background-color: ${({ theme }) => theme.body};
`;


const Footer: React.FC = () => (
  <Foot>
    <LocalTime />
  </Foot>
);

export default React.memo(Footer);